export function formatProductNameAndDescription(
  name?: string,
  description?: string,
): string {
  const n = (name ?? "").trim();
  const d = (description ?? "").trim();

  if (!n && !d) return "";
  if (!n) return d;
  if (!d) return n;

  return `${n} - ${d}`;
}
